import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import LayerDriftSeverityBadge from "@/v2-backoffice-client/layer/drift/LayerDriftSeverityBadge"
import type { LayerDriftFragment } from "@/v2-backoffice-client/layer/drift/__types__/layer.drift.fragment"

export type LayerDriftSummaryBadgesProps = ComponentProps<"div"> & {
  detail: LayerDriftFragment
}

// LayerDriftSummaryBadges renders the row of "N breaking · N warning ·
// N info" pills that sits under the drift status text in the header.
// Empty severity counts are skipped so a target with only warnings
// doesn't show a "0 breaking" chip.
function LayerDriftSummaryBadges(props: LayerDriftSummaryBadgesProps) {
  const { detail, className, ...divProps } = props

  if (!detail.HasDrift) {
    return null
  }

  return (
    <div
      className={cn("text-xs flex items-center gap-2", className)}
      {...divProps}
    >
      {detail.BreakingCount > 0 && (
        <LayerDriftSeverityBadge severity="breaking">
          {detail.BreakingCount} breaking
        </LayerDriftSeverityBadge>
      )}
      {detail.WarningCount > 0 && (
        <LayerDriftSeverityBadge severity="warning">
          {detail.WarningCount} warning
        </LayerDriftSeverityBadge>
      )}
      {detail.InfoCount > 0 && (
        <LayerDriftSeverityBadge severity="info">
          {detail.InfoCount} info
        </LayerDriftSeverityBadge>
      )}
    </div>
  )
}

export default LayerDriftSummaryBadges
